import React, { useEffect, useState } from "react";
import { Container, Row, Col, Modal, Button, Spinner } from "react-bootstrap";
import ChooseCar from "../../../Header/ChooseCar";
import { connect } from "react-redux";
import {
  AppliedCartOffers,
  fetchCartAddons,
  setCartBatteryParameter,
  setCartJobItems,
  setCartJourney,
  setCartProducts,
  setCartStage,
  setCartTypeParameter,
  setCartWorkshop,
  setSelectedQuotationForm,
  setShowMobileIstand,
} from "../../../../redux/actions/cartAction";
import toast from "react-hot-toast";
import { FaHome, FaRegFilePdf } from "react-icons/fa";
import {
  batteryQuotation,
  normalQuotation,
  obWorkshop,
  tyreQuotation,
  workshopPurchase,
} from "../../../../lib/config";
import {
  getCategory,
  getVariants,
  getWorkshopFilterMap,
  getWorkshopFilterMapMultiple,
  getWorkshopsJourneyVariant,
  getWorkshopsProductCategory,
} from "../../../../redux/actions/apiActions";
import { isMobile } from "react-device-detect";
import ReadMoreReact from "read-more-react/dist/components/ReadMoreReact";
import { useRouter } from "next/router";
import EmptyCartModal from "../EmptyCartModal";
import { resetCart, saveCart, saveCartJobs } from "../../../../lib/cart";
import {
  gtmBrandIcons,
  gtmChooseService,
} from "../../../../lib/google-tag-manager";
import { setLayer } from "../../../../redux/actions/globalAction";
import API from "api";
import Offers from "../Offers";
import CommonModel from "components/common/CommonModel";
import { workshopSelection } from "actions/Cart";
import ChooseCarMobile from "components/common/ChooseCarMobile";
import { MdInfoOutline } from "react-icons/md";
import {
  gtm_ecommerce_add_to_cart,
  gtm_ecommerce_remove_from_cart,
  gtm_ecommerce_select_item,
  gtm_ecommerce_select_promotion,
} from "lib/GA4_tag";

let header = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

const ServiceListItem = ({
  showDescription,
  setShowDescription,
  setTypeOne,
  variant,
  getCarBrandModal,
  getModel,
  getWorkshopFilterMap,
  setCartStage,
  setCartProducts,
  cart,
  isSlug,
  globalData,
  apiData,
  setCartJobItems,
  fetchCartAddons,
  setCartJourney,
  setCartWorkshop,
  index,
  setShowMobileIstand,
  setSelectedQuotationForm,
  getCategory,
  id,
  setLayer,
  setCartBatteryParameter,
  setCartTypeParameter,
  getVariants,
  AppliedCartOffers,
  getWorkshopsJourneyVariant,
  getWorkshopsProductCategory,
}) => {
  const [selected, setSelected] = useState(null);
  const [changeBrandModalShow, setChangeBrandModalShow] = useState(false);
  const [changeOfferModalShow, setChangeOfferModalShow] = useState(false);
  const [defaultProduct, setDefaultProduct] = useState(variant.Products[0]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showEmpty, setShowEmpty] = useState(false);
  const [showQuoteSelect, setShowQuoteSelect] = useState(false);
  const [chooseOil, setChooseOil] = useState("");
  const [showtabby, setShowtabby] = useState(false);
  const [tabbyModel, setTabbyModel] = useState(false);
  const [CurrentOffers, setCurrentOffers] = useState([]);
  const [discountValue, setDiscountValue] = useState(0);
  const [showCarPopUp, setShowCarPopUp] = useState(false);
  const [fittingChecked, setFittingChecked] = useState(
    Boolean(
      JSON.parse(
        sessionStorage.getItem("get-fitting-at-home") ?? JSON.stringify([])
      ).length
    )
  );
  const [showReset, setShowReset] = useState(false);

  const router = useRouter();
  const addOffers = (offers, show = false) => {
    const filterCategory = globalData.currentCategory?.filter(
      (item) => item.ID == variant.JourneyCategoryId
    );
    if (offers && !show) {
      const event = {
        promotion_id: offers.PromotionId,
        promotion_name: offers.PromotionName,
        items: [
          {
            item_id: variant.Id,
            item_name: variant.Name,
            coupon: offers.PromotionCode || offers.PromotionId,
            discount: variant.DiscountedCost || 0,
            item_category: filterCategory[0]?.Name,
            item_list_id: filterCategory[0]?.ID,
            item_list_name: filterCategory[0]?.Name,
            price: variant.Cost,
            quantity: 1,
          },
        ],
      };

      gtm_ecommerce_select_promotion(event);
    }
    const immutableOffer = { ...offers };
    if (cart.workshop) {
      const offer = cart.workshop.Offers
        ? cart.workshop.Offers.find((e) => {
            return e?.PromotionId === immutableOffer.PromotionId;
          })
        : null;
      if (offer) immutableOffer.isOfferWorkshopSelected = true;
    }
    AppliedCartOffers(immutableOffer);
    if (!show) {
      setChangeOfferModalShow(false);
    }
  };

  useEffect(() => {
    const SHOW_TABBY_PAY = variant?.Cost > 450 || defaultProduct?.Cost > 450;
    setShowtabby(
      SHOW_TABBY_PAY && process.env.NEXT_PUBLIC_ACTIVE_TABBY_PAYMENT
    );
  }, [variant]);
  let { products, jobItems, workshop } = cart;
  let excludedVariantIds = [];
  for (let i = 0; i < products?.length; i++) {
    if (products[i]?.ExcludeVariants?.length !== 0) {
      for (let j = 0; j < products[i]?.ExcludeVariants?.length; j++) {
        excludedVariantIds.push(
          products[i].ExcludeVariants[j].ExcludeJourneyVariantId
        );
      }
    }
  }

  useEffect(() => {
    setDefaultProduct(variant.Products[0]);
    if (variant?.IslandType === tyreQuotation) {
      setCartJourney(workshopPurchase);
    }
  }, [variant.Products]);

  const productNavigate = () => {
    let immutableUrl = "/";
    router.query.slug?.map((item, index) => {
      immutableUrl += index == 1 ? variant.Slug : item;
      immutableUrl += "/";
      return item;
    });
    router.push(
      {
        pathname: `/services/[...slug]`,
      },
      "/services" + immutableUrl,
      { shallow: true }
    );
  };

  useEffect(() => {
    if (variant.IslandType == workshopPurchase) {
      localStorage.removeItem("isQuoterequest");
      if (showQuoteSelect) {
        setLayer(false);
        setShowQuoteSelect(false);
        localStorage.removeItem("isQuoterequest");
      }
    }
    return () => {
      localStorage.removeItem("isQuoterequest");
    };
  }, [variant]);

  const isQuoterequest = localStorage.getItem("isQuoterequest");

  const handleWorkshopSelection = async (
    brandId = defaultProduct && defaultProduct.Id ? defaultProduct.Id : 1,
    Cost = defaultProduct && defaultProduct.Cost ? defaultProduct.Cost : 0
  ) => {
    brandId =
      variant && variant?.Products && variant.Products?.length ? brandId : null;

    setIsSubmitting(true);

    let offer;
    const isOfferApplied = cart.appliedCartOffers?.variantId == variant?.Id;

    if (isOfferApplied) {
      offer = variant.Offers.filter(
        (item) => item.PromotionId == cart.appliedCartOffers?.PromotionId
      );
    }
    const filterCategory = globalData.currentCategory?.filter(
      (item) => item.ID == variant.JourneyCategoryId
    );

    const event = {
      item_list_id: filterCategory[0].ID,
      item_list_name: filterCategory[0].Name,
      items: [
        {
          item_id: variant.Id,
          item_name: variant.Name,
          coupon: offer?.length
            ? offer[0]?.PromotionCode || offer[0].PromotionId
            : null,
          discount: variant.DiscountedCost || 0,
          item_category: filterCategory[0].Name,
          item_list_id: filterCategory[0].ID,
          item_list_name: filterCategory[0].Name,
          price: variant.Cost,
          quantity: 1,
        },
      ],
    };

    gtm_ecommerce_select_item(event);

    const isQuoterequest = localStorage.getItem("isQuoterequest");

    if (showQuoteSelect || isQuoterequest) {
      setShowQuoteSelect(false);
      getVariants(
        variant.JourneyCategoryId,
        globalData?.carData?.modelId,
        cart.workshop?.Id
      );
      localStorage.removeItem("isQuoterequest");
    }
    gtmChooseService(variant?.Name);
    if (variant.IslandType == obWorkshop) {
      sessionStorage.setItem("isWorkshopCollection", true);
      localStorage.setItem("obWorkshop", true);
    } else {
      sessionStorage.removeItem("isWorkshopCollection");
      localStorage.removeItem("obWorkshop");
    }
    if (isMobile) {
      setShowMobileIstand(true);
    }
    setLayer(true);
    if (variant.IslandType === tyreQuotation) {
      setShowQuoteSelect(true);
      localStorage.setItem("isQuoterequest", true);
      setCartJourney(tyreQuotation);
      localStorage.setItem("product-id", JSON.stringify(variant.Id));
      setSelectedQuotationForm(variant);
      setIsSubmitting(false);
      productNavigate();
      return;
    }
    if (variant.IslandType === batteryQuotation) {
      setShowQuoteSelect(true);
      localStorage.setItem("isQuoterequest", true);
      localStorage.setItem("product-id", JSON.stringify(variant.Id));
      setCartJourney(batteryQuotation);
      setSelectedQuotationForm(variant);
      setIsSubmitting(false);
      productNavigate();
      return;
    }
    if (variant.Cost <= 0) {
      setShowQuoteSelect(false);
      localStorage.removeItem("isQuoterequest");
      setCartJourney(normalQuotation);
      setSelectedQuotationForm(variant);

      setIsSubmitting(false);
      productNavigate();
      return;
    }
    if (variant.IslandType === workshopPurchase) {
      setShowQuoteSelect(false);
      localStorage.removeItem("isQuoterequest");
      setCartJourney(workshopPurchase);
      setCartStage(1);
      setIsSubmitting(false);
    }
    if (variant.IslandType === obWorkshop) {
      setShowQuoteSelect(false);
      localStorage.removeItem("isQuoterequest");
      setCartJourney(workshopPurchase);
      setCartStage(3);
      setCartWorkshop(apiData.defaultWorkshop);
      setIsSubmitting(false);
    }
    setTypeOne(0);
    const result = products.filter(
      (res, index) => res.JourneyVariantId == variant.Id
    );
    if (
      result.length == 0 &&
      ((workshop != null && workshop?.Id != undefined && workshop?.Id != "") ||
        variant.IslandType === obWorkshop)
    ) {
      try {
        const res = await workshopSelection(
          variant.IslandType === obWorkshop
            ? apiData.defaultWorkshop?.Id
            : workshop?.Id,
          variant.Id,
          globalData.carData?.modelId,
          brandId
        );
        if (res.err) {
          showLoader(false);
          return;
        }
        setCartProducts([...products, variant]);
        setCartJobItems([...jobItems, { ...res.Data[0], BrandId: brandId }]);
        saveCartJobs(cart, apiData, globalData, [
          ...jobItems,
          { ...res.Data[0], BrandId: brandId },
        ]);
        fetchCartAddons(
          variant.IslandType === obWorkshop
            ? apiData.defaultWorkshop?.Id
            : cart.workshop.Id,
          variant.Id,
          globalData.carData?.modelId
        );
      } catch (error) {
        console.log("Error", error);
        setIsSubmitting(false);
      }
    } else {
      setCartProducts([variant]);
    }
    setSelected(variant.Id);
    localStorage.setItem("product-id", JSON.stringify(variant.Id));
    localStorage.setItem(
      "product-amount",
      JSON.stringify(Cost ? Cost : variant.Cost)
    );
    localStorage.setItem("brand-id", brandId);
    getWorkshopFilterMap(
      40,
      1,
      globalData.locationData?.lat,
      globalData.locationData?.lng,
      variant.Id,
      globalData.carData?.modelId,
      "Distance",
      brandId
    );
    setIsSubmitting(false);
    productNavigate();
  };

  const addToCart = async () => {
    let offer;
    const isOfferApplied = cart.appliedCartOffers?.variantId == variant?.Id;

    if (isOfferApplied) {
      offer = variant.Offers.filter(
        (item) => item.PromotionId == cart.appliedCartOffers?.PromotionId
      );
    }
    const filterCategory = globalData.currentCategory?.filter(
      (item) => item.ID == variant.JourneyCategoryId
    );

    const event = {
      currency: "AED",
      value: variant.Cost,
      items: [
        {
          item_id: variant.Id,
          item_name: variant.Name,
          coupon: offer?.length
            ? offer[0]?.PromotionCode || offer[0].PromotionId
            : null,
          discount: variant.DiscountedCost || 0,
          item_category: filterCategory[0]?.Name,
          item_list_id: filterCategory[0]?.ID,
          item_list_name: filterCategory[0]?.Name,
          price: variant.Cost,
          quantity: 1,
        },
      ],
    };
    gtm_ecommerce_add_to_cart(event);
    setLayer(true);
    setIsSubmitting(true);
    // if (isMobile) {
    //   setShowMobileIstand(true);
    // }

    const result = products.filter((res, index) => res.Id == variant.Id);
    if (result.length == 0) {
      try {
        const { data: res } = await API.get(
          `v2/api/workshops/${workshop?.Id}/jobs?page=1&variantId=${variant.Id}&carModelId=${globalData.carData?.modelId}&sortingCol=Distance&workshopId=${workshop?.Id}&lat=1&lng=1&size=40&brandId=${defaultProduct?.Id}`,
          {
            headers: header,
          }
        );
        localStorage.setItem(
          "service-selected",
          JSON.stringify({ ...res.Data[0], BrandId: defaultProduct?.Id })
        );
        if (variant.IsHomeServiceAvailable) {
          const getFittingAtHome = sessionStorage.getItem(
            "get-fitting-at-home"
          );
          let value = JSON.parse(getFittingAtHome ?? JSON.stringify([]));
          value.push(variant.Id);
          sessionStorage.setItem("get-fitting-at-home", JSON.stringify(value));
        }
        setCartProducts([...products, variant]);
        setCartJobItems([
          ...jobItems,
          { ...res.Data[0], BrandId: defaultProduct?.Id },
        ]);
        setCartStage(2);
        saveCartJobs(cart, apiData, globalData, [
          ...jobItems,
          { ...res.Data[0], BrandId: defaultProduct?.Id },
        ]);
        setIsSubmitting(false);
        productNavigate();
      } catch (e) {
        console.log("Error", e);
        setIsSubmitting(false);
      }
    } else {
      toast.dismiss();
      toast.error("Already Added!");
      setIsSubmitting(false);
    }
  };

  const removeFromCartEvent = () => {
    let offer;
    const isOfferApplied = cart.appliedCartOffers?.variantId == variant?.Id;

    if (isOfferApplied) {
      offer = variant.Offers.filter(
        (item) => item.PromotionId == cart.appliedCartOffers?.PromotionId
      );
    }
    const filterCategory = globalData.currentCategory?.filter(
      (item) => item.ID == variant.JourneyCategoryId
    );

    const event = {
      currency: "AED",
      value: variant.Cost,
      items: [
        {
          item_id: variant.Id,
          item_name: variant.Name,
          coupon: offer?.length
            ? offer[0]?.PromotionCode || offer[0].PromotionId
            : null,
          discount: variant.DiscountedCost || 0,
          item_category: filterCategory[0].Name,
          item_list_id: filterCategory[0].ID,
          item_list_name: filterCategory[0].Name,
          price: variant.Cost,
          quantity: 1,
        },
      ],
    };

    gtm_ecommerce_remove_from_cart(event);
  };

  const removeFromCart = () => {
    setIsSubmitting(true);
    const result = products.filter((res, index) => res.Id != variant.Id);
    const resultJobItems = jobItems.filter(
      (res) => res.JourneyVariantId != variant.Id
    );

    if (result.length == 0) {
      setShowEmpty(true);
      setIsSubmitting(false);
      return;
    }

    removeFromCartEvent();

    if (result.length == 0 && !workshopURL) {
      setShowEmpty(true);
      saveCart(cart, apiData, globalData);
      saveCartJobs(cart, apiData, globalData, []);
    } else {
      setCartProducts(result);
      setCartJobItems(resultJobItems);
      saveCartJobs(cart, apiData, globalData, resultJobItems);
    }
    setIsSubmitting(false);
  };

  const changeInCart = async () => {
    let offer;
    const isOfferApplied = cart.appliedCartOffers?.variantId == variant?.Id;

    if (isOfferApplied) {
      offer = variant.Offers.filter(
        (item) => item.PromotionId == cart.appliedCartOffers?.PromotionId
      );
    }
    const filterCategory = globalData.currentCategory?.filter(
      (item) => item.ID == variant.JourneyCategoryId
    );

    const event = {
      currency: "AED",
      value: variant.Cost,
      items: [
        {
          item_id: variant.Id,
          item_name: variant.Name,
          coupon: offer?.length
            ? offer[0]?.PromotionCode || offer[0].PromotionId
            : null,
          discount: variant.DiscountedCost || 0,
          item_category: filterCategory[0].Name,
          item_list_id: filterCategory[0].ID,
          item_list_name: filterCategory[0].Name,
          price: variant.Cost,
          quantity: 1,
        },
      ],
    };
    gtm_ecommerce_add_to_cart(event);
    setIsSubmitting(true);
    // if (isMobile) {
    //   setShowMobileIstand(true);
    // }
    let removingItemId = 0;
    const remainProducts = products.filter((item, index) => {
      if (item.ExcludeVariants.length === 0) {
        setIsSubmitting(false);
        return true;
      }
      if (item.ExcludeVariants[0].ExcludeJourneyVariantId === variant.Id) {
        removingItemId = item.Id;
      }
      setIsSubmitting(false);
      return item.ExcludeVariants[0].ExcludeJourneyVariantId !== variant.Id;
    });
    const result = products.filter((res, index) => res.Id == variant.Id);
    if (result.length == 0) {
      try {
        const { data: res } = await API.get(
          `v2/api/workshops/${workshop?.Id}/jobs?page=1&variantId=${variant.Id}&carModelId=${globalData.carData?.modelId}&sortingCol=Distance&workshopId=${workshop?.Id}&lat=1&lng=1&size=40`,
          {
            headers: header,
          }
        );
        localStorage.setItem("service-selected", JSON.stringify(res.Data[0]));
        // setCartProducts([...products, res.Data[0]])
        let jobs = jobItems.filter(
          (res, index) => res.JourneyVariantId !== removingItemId
        );
        setCartProducts([...remainProducts, variant]);
        setCartJobItems([...jobs, res.Data[0]]);
        setIsSubmitting(false);
        const getFittingAtHome = sessionStorage.getItem("get-fitting-at-home");
        let value = JSON.parse(getFittingAtHome ?? JSON.stringify([]));
        value.filter((item) => item != removingItemId);
        value.push(variant.Id);
        sessionStorage.setItem("get-fitting-at-home", JSON.stringify(value));
        saveCartJobs(cart, apiData, globalData, [...jobs, res.Data[0]]);
      } catch (error) {
        console.log("Error", error);
        alert("something went wrong");
        setIsSubmitting(false);
      }
    } else {
      toast.dismiss();
      toast.error("Already Added!");
      setIsSubmitting(false);
    }
  };

  const changeProduct = (product) => {
    setChooseOil(product.Name);
    gtmBrandIcons(product.Name);
    setDefaultProduct(product);
    // handleWorkshopSelection(product.Id, product.Cost);
    setChangeBrandModalShow(false);
  };

  const handleUnselect = () => {
    setCartStage(null);
    if (!sessionStorage.getItem("isWorkshopCollection")) setCartWorkshop(null);
  };
  let checkAdded =
    products?.filter((item) => item.Id === variant.Id).length === 1;

  let data = variant.Products.map((item, index) => {
    return {
      name: item.Name,
      src: item.ImageUrl,
    };
  });
  const workshopURL =
    router.query.slug &&
    cart.workshop &&
    router.query.slug[3] == cart.workshop?.Slug;

  const isSelected =
    products?.filter((prod) => prod.Id == variant.Id).length === 1;

  const CurrentPage =
    router?.query && router?.query?.slug && router?.query?.slug?.length
      ? router?.query?.slug[1]
      : "";
  let category = "";
  if (typeof localStorage !== "undefined") {
    category = localStorage.getItem("selected-service");
  }

  const handleshowOffers = (offer) => {
    setChangeOfferModalShow(true);
    setCurrentOffers(offer);
  };

  useEffect(() => {
    if (
      cart.appliedCartOffers &&
      ((cart.appliedCartOffers.PromotionType != "WorkshopProductPromotion" &&
        cart.appliedCartOffers.PromotionType != "WorkshopPromotion") ||
        ((cart.appliedCartOffers.PromotionType == "WorkshopProductPromotion" ||
          cart.appliedCartOffers.PromotionType == "WorkshopPromotion") &&
          cart.appliedCartOffers?.isOfferWorkshopSelected))
    ) {
      const isOfferAvailable =
        variant.Offers && variant?.Offers.length
          ? variant.Offers.filter(
              (offer) => offer.PromotionId == cart.appliedCartOffers.PromotionId
            ).length
          : false;
      if (!isOfferAvailable) {
        setDiscountValue(0);
        return;
      }
      const cost = parseFloat(
        defaultProduct?.Cost ? defaultProduct.Cost : variant?.OrginalCost
      );
      const discountPercentage = cart?.appliedCartOffers?.PromotionPercentValue
        ? parseFloat(cart?.appliedCartOffers?.PromotionPercentValue)
        : 0;
      const d_amount = (cost * discountPercentage) / 100;
      const flatvalue = parseFloat(
        cart?.appliedCartOffers?.PromotionFlatValue
          ? cart?.appliedCartOffers?.PromotionFlatValue
          : 0
      );
      const remainingValue = cost - d_amount - flatvalue;
      setDiscountValue(parseFloat(remainingValue).toFixed(2));
    } else {
      setDiscountValue(0);
    }
  }, [cart.appliedCartOffers, variant, defaultProduct]);

  return (
    <>
      <div className={`${isSlug ? "blink-service col-md-12" : "col-md-12"}`}>
        <ChooseCarMobile show={showCarPopUp} setShow={setShowCarPopUp} />
        <div className="product-tabby-text">
          <CommonModel
            istabby={true}
            show={tabbyModel}
            onHide={() => {
              setTabbyModel(false);
            }}
          >
            <iframe
              id="tabby-installment-iframe"
              src="https://checkout.tabby.ai/promos/product-page/installments/en/"
              height="546px"
              width="100%"
              style={{ borderWidth: 0 }}
            ></iframe>
          </CommonModel>
        </div>
        <EmptyCartModal
          id={id}
          show={showEmpty}
          onHide={() => {
            setShowEmpty(false);
          }}
          title="Are you sure?"
          message="By removing last item, your cart will be reset to empty cart."
          getCategory={getCategory}
        />

        <EmptyCartModal
          id={id}
          show={showReset}
          onHide={() => {
            setShowReset(false);
          }}
          title="Are you sure?"
          message={`By removing "Get Fitting at Home" service from your order, your cart will be reset to empty cart`}
          getCategory={getCategory}
        />

        {changeOfferModalShow ? (
          <Offers
            setChangeOfferModalShow={setChangeOfferModalShow}
            changeOfferModalShow={changeOfferModalShow}
            offers={CurrentOffers}
            addOffers={addOffers}
            cart={cart}
            variant={variant}
          />
        ) : (
          ""
        )}
        <>
          <div
            className="listing-container-pl border-pl-list"
            style={{ backgroundColor: checkAdded && "#f3f4ff" }}
          >
            <div className="row">
              <div className="col-md-12">
                <div className="product-section-pl-header">
                  <div className="product-section-pl-hd-flex">
                    <h3>{variant.Name}</h3>
                    <label
                      style={
                        variant.IsRecommended || variant.LableText
                          ? {}
                          : { display: "none" }
                      }
                    >
                      {variant?.IsRecommended ? (
                        <span className="rec-lab">
                          Recommended <i className="fa-regular fa-thumbs-up" />
                        </span>
                      ) : null}
                      {variant?.LableText ? (
                        <span
                          className="free-lab"
                          style={{
                            background:
                              "linear-gradient(0deg, rgba(247,146,34,1) 0%, rgba(255,50,1,1) 100%)",
                            color: "white",
                          }}
                        >
                          {variant?.LableText}
                          {/* Free Regular Service */}
                        </span>
                      ) : null}
                    </label>
                  </div>
                  {/* <div className="mnf-yrs">Year of Manufacture 2019</div> */}
                </div>
              </div>
              <div className="pl-fl-box">
                <div className="pl-fl-img">
                  <div className="position-relative-pr">
                    <label>
                      <i className="fa-clock-cs">
                        <img src="/assets/products/clock.svg" />
                      </i>
                      {variant.TimeDuration + " "}
                    </label>
                    <img
                      className="product-image-container-pl"
                      src={variant.ImgUrl || "/assets/images/workshop.jpg"}
                    />
                  </div>
                </div>
                <div className="pl-fl-ft-sec custom-height-sec">
                  <div className="pl-fl-lst min-pl-height">
                    <Row className="mt-2">
                      {showDescription != variant.Id
                        ? variant.InfoLines != null &&
                          variant.InfoLines.slice(0, isMobile ? 3 : 4).map(
                            (infoLine, index) => (
                              <>
                                <Col lg={6} className="product-content d-flex">
                                  <img
                                    className="product-content-image mr-1"
                                    src="/assets/images/tick.webp"
                                  />
                                  <ReadMoreReact
                                    text={infoLine.Description}
                                    min={10}
                                    readMoreText={
                                      <a className="text-primary">Read More</a>
                                    }
                                  />
                                </Col>
                              </>
                            )
                          )
                        : variant.InfoLines != null &&
                          variant.InfoLines.map((infoLine, index) => (
                            <>
                              <Col lg={6} className="product-content d-flex">
                                <img
                                  className="product-content-image mr-1"
                                  src="/assets/images/tick.webp"
                                />
                                <ReadMoreReact
                                  text={infoLine.Description}
                                  min={10}
                                  readMoreText={
                                    <a className="text-primary">Read More</a>
                                  }
                                />
                              </Col>
                            </>
                          ))}
                      {variant.InfoLines.length > (isMobile ? 3 : 4) && (
                        <Col
                          lg={6}
                          onClick={() => {
                            setShowDescription(
                              showDescription == variant.Id ? false : variant.Id
                            );
                          }}
                          role="button"
                          className="product-content"
                        >
                          <label>
                            {showDescription == variant.Id
                              ? "- View Less"
                              : "+ View More"}
                          </label>
                        </Col>
                      )}
                    </Row>
                    {process.env.NEXT_PUBLIC_ACTIVATE_VIEW_INSPECTION_BUTTON &&
                    variant?.SampleDocuments &&
                    variant.SampleDocuments?.length ? (
                      <div className={"custom-pdf-ob mt-1 mb-2 mb-md-0"}>
                        <a
                          href={
                            variant.SampleDocuments[0]?.SourceUrl ||
                            "about:blank"
                          }
                          target="_blank"
                        >
                          {variant.SampleDocuments[0]?.Name}{" "}
                        </a>
                      </div>
                    ) : null}
                  </div>
                  <div className="pl-feture-first dsk-view">
                    <div className="oft-lbs">
                      {variant.Offers && variant.Offers?.length ? (
                        <label
                          className="pl-offer-label"
                          title={"Offer Available"}
                          onClick={() => handleshowOffers(variant.Offers)}
                        >
                          <img src="/assets/products/party-icon.webp" />
                          {variant.Offers?.length}{" "}
                          {variant.Offers?.length == 1 ? "Offer" : "Offers"}{" "}
                          Available
                        </label>
                      ) : null}

                      <label class="pl--tl-workshop">
                        <img
                          width={15}
                          height={13}
                          style={{ marginBottom: "2px" }}
                          src="/assets/header/ob-network-new-logo.svg"
                          alt="Image"
                        />
                        {variant?.WorkshopCount} Workshops
                      </label>
                    </div>
                  </div>
                  <div className="price-pl-blck dsk-view">
                    <div className="price-pl-lf">
                      <label className="price-tag-pl">
                        {cart.workshop && globalData.carData?.brand ? (
                          <div className="dst-price-item">
                            <p>Best Price</p>
                            <strong>AED</strong>

                            <strong
                              className={
                                discountValue ? "offer-applied-ui" : ""
                              }
                            >
                              {parseFloat(variant.Cost).toFixed(2)}
                            </strong>

                            {discountValue ? (
                              <strong className={""}>
                                {" "}
                                <>{parseFloat(discountValue || 0).toFixed(2)}</>
                              </strong>
                            ) : null}
                          </div>
                        ) : (
                          <>
                            {globalData.carData?.brand && variant.Cost > 0 && (
                              <>
                                <div className="dst-price-item">
                                  <p>Best Price</p>
                                  <strong>AED</strong>

                                  <strong
                                    className={
                                      discountValue ? "offer-applied-ui" : ""
                                    }
                                    style={{ whiteSpace: "pre-wrap" }}
                                  >
                                    {defaultProduct ? (
                                      <>
                                        {parseFloat(
                                          defaultProduct.Cost
                                        ).toFixed(2)}{" "}
                                      </>
                                    ) : (
                                      parseFloat(variant.Cost).toFixed(2)
                                    )}{" "}
                                  </strong>

                                  {discountValue ? (
                                    <strong
                                      className={discountValue ? "" : "px-1"}
                                    >
                                      {" "}
                                      <>
                                        {parseFloat(discountValue || 0).toFixed(
                                          2
                                        )}
                                      </>
                                    </strong>
                                  ) : null}
                                </div>
                              </>
                            )}
                          </>
                        )}
                      </label>
                    </div>
                    <div className="price-pl-rght">
                      {variant.IsHomeServiceAvailable &&
                      ((cart.workshop && cart.workshop.Id == 1001) ||
                        !cart.workshop) ? (
                        <div class="fitting-checkbox">
                          <label className="chk-label">
                            Get Fitting at Home
                            <input
                              type="checkbox"
                              checked={fittingChecked}
                              onChange={(e) => {
                                const getFittingAtHome = sessionStorage.getItem(
                                  "get-fitting-at-home"
                                );
                                let value = JSON.parse(
                                  getFittingAtHome ?? JSON.stringify([])
                                );
                                if (!fittingChecked && !value.length) {
                                  sessionStorage.setItem(
                                    "isWorkshopCollection",
                                    true
                                  );
                                  localStorage.removeItem(
                                    "isFirstJourneySteps"
                                  );
                                  setCartWorkshop(apiData.defaultWorkshop);
                                } else {
                                  setShowReset(true);
                                  return;
                                }
                                const data = value.filter(
                                  (item) => item == variant.Id
                                );
                                if (data.length)
                                  value = value.filter(
                                    (item) => item != variant.Id
                                  );
                                else value.push(variant.Id);
                                sessionStorage.setItem(
                                  "get-fitting-at-home",
                                  JSON.stringify(value)
                                );
                                setFittingChecked(!fittingChecked);
                              }}
                            />
                            <span className="check-mark"></span>
                          </label>
                          <small>AED 100.00 Extra Charge</small>
                        </div>
                      ) : null}

                      {data.length > 1 && (
                        <div
                          className="oil-brand-sl "
                          data-toggle="modal"
                          data-target="#oilModal"
                          onClick={() => setChangeBrandModalShow(true)}
                        >
                          <span>Choose Oil brand</span>
                          <strong>
                            {chooseOil == "" ? data[0].name : chooseOil}
                          </strong>
                          <i className="fa-solid fa-caret-down" />
                        </div>
                      )}
                      {globalData.carData != null ? (
                        isSelected &&
                        cart.stage == 1 &&
                        cart.journeyType === workshopPurchase ? (
                          <>
                            <Button
                              className="workshop-button-one bg-yellow"
                              onClick={() => handleUnselect()}
                              disabled={isSubmitting}
                            >
                              Remove{" "}
                              {isSubmitting && (
                                <Spinner
                                  animation="grow"
                                  role="status"
                                  className="ml-2"
                                  size="sm"
                                >
                                  <span className="visually-hidden"></span>
                                </Spinner>
                              )}
                            </Button>
                          </>
                        ) : (
                          <>
                            {excludedVariantIds.includes(variant.Id) &&
                            cart.jobItems.length !== 0 ? (
                              <Button
                                onClick={changeInCart}
                                className="workshop-button-one shine-animation-new"
                                disabled={checkAdded || isSubmitting}
                              >
                                {/* {checkAdded ? "Added" : "Change"} */}
                                Switch
                                {isSubmitting && (
                                  <Spinner
                                    animation="grow"
                                    role="status"
                                    className="ml-2"
                                    size="sm"
                                  >
                                    <span className="visually-hidden"></span>
                                  </Spinner>
                                )}
                              </Button>
                            ) : (
                              <>
                                {cart.workshop ? (
                                  <>
                                    {checkAdded ? (
                                      <Button
                                        onClick={removeFromCart}
                                        className="workshop-button-one remove"
                                        disabled={isSubmitting}
                                        // disabled={
                                        //   excludedVariantIds.includes(variant.Id) ||
                                        //   checkAdded
                                        // }
                                      >
                                        {/* {checkAdded ? "Added" : "Add to cart"} */}
                                        Remove{" "}
                                        {isSubmitting && (
                                          <Spinner
                                            animation="grow"
                                            role="status"
                                            className="ml-2"
                                            size="sm"
                                          >
                                            <span className="visually-hidden"></span>
                                          </Spinner>
                                        )}
                                      </Button>
                                    ) : (
                                      <Button
                                        onClick={addToCart}
                                        className="workshop-button-one shine-animation-new"
                                        disabled={isSubmitting}
                                        //   disabled={
                                        //     excludedVariantIds.includes(variant.Id) ||
                                        //     checkAdded
                                        //   }
                                      >
                                        Add to cart{" "}
                                        {isSubmitting && (
                                          <Spinner
                                            animation="grow"
                                            role="status"
                                            className="ml-2"
                                            size="sm"
                                          >
                                            <span className="visually-hidden"></span>
                                          </Spinner>
                                        )}
                                      </Button>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <Button
                                      onClick={() => {
                                        localStorage.setItem(
                                          "product-id",
                                          variant.Id
                                        );
                                        if (showQuoteSelect) {
                                          setShowQuoteSelect(false);
                                          localStorage.removeItem(
                                            "isQuoterequest"
                                          );
                                          setCartJourney(workshopPurchase);
                                          let tyreItem = cart.tyreQuotation;
                                          tyreItem.isProceed = false;
                                          tyreItem.width = null;
                                          tyreItem.height = null;
                                          tyreItem.rim = null;
                                          tyreItem.data = null;
                                          setCartTypeParameter(tyreItem);
                                          let item = cart.batteryQuotation;
                                          item.isProceed = false;
                                          item.data = null;
                                          item.type = null;
                                          console.log(" ", variant.Id);
                                          setCartBatteryParameter(item);
                                          return;
                                        }
                                        handleWorkshopSelection();
                                      }}
                                      className={`workshop-button-one variant-${index} ${
                                        showQuoteSelect
                                          ? isMobile
                                            ? "quote-yellow"
                                            : "quote-yellow"
                                          : ""
                                      } shine-animation-new`}
                                      style={
                                        variant.Cost <= 0
                                          ? {
                                              padding: showQuoteSelect
                                                ? "18px 50px"
                                                : "18px 35px",
                                              marginTop: "5px",
                                              // marginLeft: isMobile
                                              //   ? "94px"
                                              //   : "0px",
                                            }
                                          : {}
                                      }
                                      disabled={isSubmitting}
                                    >
                                      {/* {variant.Cost > 0 ? "Select" : "Request Quote"} */}
                                      {variant.Cost > 0
                                        ? "Select"
                                        : variant.Cost < 0 &&
                                          !showQuoteSelect &&
                                          !isQuoterequest
                                        ? "Request Quote"
                                        : "Remove"}
                                      {/* {variant.Id == 55 ? "Select" : "Request Quote"} */}{" "}
                                      {isSubmitting && (
                                        <Spinner
                                          animation="grow"
                                          role="status"
                                          className="ml-2"
                                          size="sm"
                                        >
                                          <span className="visually-hidden"></span>
                                        </Spinner>
                                      )}
                                    </Button>
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )
                      ) : (
                        <ChooseCar
                          // CHoose Car to View Price
                          globalData={globalData}
                          style={"workshop-button-one"}
                          textTrue={true}
                          apiData={apiData}
                          getModel={getModel}
                          getCarBrandModal={getCarBrandModal}
                          text="Choose Car to View Price"
                          // mobileCartView
                          showMobileBtn={isMobile ? true : false}
                        />
                      )}
                      {/* <button className="srv-act-action">Select</button> */}
                    </div>
                  </div>
                  {variant.IsHomeServiceAvailable &&
                  ((cart.workshop && cart.workshop.Id == 1001) ||
                    !cart.workshop) ? (
                    <div class="fitting-checkbox show-mobile">
                      <label className="chk-label">
                        Get Fitting at Home
                        <input
                          type="checkbox"
                          checked={fittingChecked}
                          onChange={(e) => {
                            const getFittingAtHome = sessionStorage.getItem(
                              "get-fitting-at-home"
                            );
                            let value = JSON.parse(
                              getFittingAtHome ?? JSON.stringify([])
                            );
                            if (!fittingChecked && !value.length) {
                              sessionStorage.setItem(
                                "isWorkshopCollection",
                                true
                              );
                              localStorage.removeItem("isFirstJourneySteps");
                              setCartWorkshop(apiData.defaultWorkshop);
                            } else {
                              setShowReset(true);
                              return;
                            }
                            const data = value.filter(
                              (item) => item == variant.Id
                            );
                            if (data.length)
                              value = value.filter(
                                (item) => item != variant.Id
                              );
                            else value.push(variant.Id);
                            sessionStorage.setItem(
                              "get-fitting-at-home",
                              JSON.stringify(value)
                            );
                            setFittingChecked(!fittingChecked);
                          }}
                        />
                        <span className="check-mark"></span>
                      </label>
                      <small>AED 100.00 Extra Charge</small>
                    </div>
                  ) : null}
                  {showtabby ? (
                    <div className="tabby-bar-pr-list dsk-tabby mt-2">
                      <img src="/assets/images/tabby.webp" />
                      <p>
                        Split in 4 interest-free payments of{" "}
                        <strong>AED 212.75</strong> / month{" "}
                        <span onClick={() => setTabbyModel(true)}>
                          <MdInfoOutline size={16} />
                        </span>
                      </p>
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="mobile-pl-bar-action">
                {showtabby ? (
                  <div className="tabby-bar-pr-list mob-tabby mt-2">
                    <img src="/assets/images/tabby.webp" />
                    <p>
                      Split in 4 interest-free payments of{" "}
                      <strong>AED 212.75</strong> / month
                      <span onClick={() => setTabbyModel(true)}>
                        <MdInfoOutline size={16} />
                      </span>
                    </p>
                  </div>
                ) : (
                  ""
                )}

                <div className="mobile-bottom-sr-select mobile-bottom-direction">
                  <div className="pl-feture-first">
                    <div className="price-pl-lf">
                      <label className="price-tag-pl">
                        {cart.workshop && globalData.carData?.brand ? (
                          <>
                            <p
                              style={{
                                margin: 0,
                                padding: 0,
                                lineHeight: "15px",
                              }}
                            >
                              Best Price
                            </p>
                            <strong>
                              AED{" "}
                              <strong
                                style={{
                                  lineHeight: "10px",
                                  fontWeight: discountValue ? 500 : "bold",
                                }}
                                className={
                                  discountValue
                                    ? "normal-txt-item offer-applied-ui"
                                    : ""
                                }
                              >
                                {parseFloat(variant.Cost).toFixed(2)}
                              </strong>
                              {discountValue ? (
                                <strong
                                  style={{
                                    lineHeight: "5px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {" "}
                                  <>{parseFloat(discountValue).toFixed(2)}</>
                                </strong>
                              ) : null}
                            </strong>
                          </>
                        ) : (
                          <>
                            {globalData.carData?.brand && variant.Cost > 0 ? (
                              <>
                                <p
                                  style={{
                                    margin: 0,
                                    padding: 0,
                                    lineHeight: "15px",
                                  }}
                                >
                                  Best Price
                                </p>
                                <strong>
                                  <>
                                    {
                                      <>
                                        <strong style={{ fontWeight: "bold" }}>
                                          AED{" "}
                                          <strong
                                            className={
                                              discountValue
                                                ? "normal-txt-item offer-applied-ui"
                                                : ""
                                            }
                                            style={
                                              discountValue
                                                ? { fontWeight: 500 }
                                                : { fontWeight: "bold" }
                                            }
                                          >
                                            {defaultProduct
                                              ? parseFloat(
                                                  defaultProduct.Cost
                                                ).toFixed(2)
                                              : parseFloat(
                                                  variant.Cost
                                                ).toFixed(2)}{" "}
                                          </strong>
                                        </strong>
                                        {discountValue ? (
                                          <strong
                                            className="normal-txt-item"
                                            style={{
                                              lineHeight: "5px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {" "}
                                            {parseFloat(discountValue).toFixed(
                                              2
                                            )}
                                          </strong>
                                        ) : null}
                                      </>
                                    }
                                  </>
                                </strong>
                              </>
                            ) : null}
                          </>
                        )}
                      </label>
                    </div>
                    {data.length > 1 ? (
                      <div
                        className="oil-brand-sl "
                        data-toggle="modal"
                        data-target="#oilModal"
                        onClick={() => setChangeBrandModalShow(true)}
                      >
                        <span>Choose Oil brand</span>
                        <strong>
                          {chooseOil == "" ? data[0].name : chooseOil}
                        </strong>
                        <i className="fa-solid fa-caret-down" />
                      </div>
                    ) : (
                      <label
                        className="pl--tl-workshop"
                        style={{
                          marginBottom:
                            globalData.carData != null ? "0px" : "-32px",
                        }}
                      >
                        {/* <i className="fa-solid fa-shop" />{" "} */}
                        <img
                          width={15}
                          height={13}
                          src="/assets/header/ob-network-new-logo.svg"
                          style={{ marginBottom: "2px" }}
                          alt="Image"
                        />
                        {variant.WorkshopCount} Workshops
                      </label>
                    )}
                  </div>
                  <div
                    className="mb-btmbar-vnt mt-0 "
                    style={{
                      marginBottom:
                        globalData.carData != null ? "-7px" : "-7px",
                    }}
                  >
                    {data.length > 1 && (
                      <label className="pl--tl-workshop">
                        <img
                          width={15}
                          height={13}
                          style={{ marginBottom: "2px" }}
                          src="/assets/header/ob-network-new-logo.svg"
                          alt="Image"
                        />
                        {/* <i className="fa-solid fa-shop" />{" "} */}
                        {variant.WorkshopCount} Workshops
                      </label>
                    )}
                    <div></div>
                  </div>
                  <div
                    className="mb-btmbar-vnt"
                    style={{
                      justifyContent: "space-between",
                    }}
                  >
                    {globalData.carData != null ? (
                      isSelected &&
                      cart.stage == 1 &&
                      cart.journeyType === workshopPurchase ? (
                        <>
                          <Button
                            className="workshop-button-one bg-yellow"
                            // style={{ marginTop: "5px" }}
                            onClick={() => handleUnselect()}
                            disabled={isSubmitting}
                          >
                            Remove{" "}
                            {isSubmitting && (
                              <Spinner
                                animation="grow"
                                role="status"
                                className="ml-2"
                                size="sm"
                              >
                                <span className="visually-hidden"></span>
                              </Spinner>
                            )}
                          </Button>
                        </>
                      ) : (
                        <>
                          {excludedVariantIds.includes(variant.Id) &&
                          cart.jobItems.length !== 0 ? (
                            <Button
                              onClick={changeInCart}
                              className="srv-act-action"
                              // style={{ marginTop: "5px" }}
                              disabled={checkAdded || isSubmitting}
                            >
                              {/* {checkAdded ? "Added" : "Change"} */}
                              Switch
                              {isSubmitting && (
                                <Spinner
                                  animation="grow"
                                  role="status"
                                  className="ml-2"
                                  size="sm"
                                >
                                  <span className="visually-hidden"></span>
                                </Spinner>
                              )}
                            </Button>
                          ) : (
                            <>
                              {cart.workshop ? (
                                <>
                                  {checkAdded ? (
                                    <Button
                                      onClick={removeFromCart}
                                      className="srv-act-action remove"
                                      disabled={isSubmitting}
                                      // disabled={
                                      //   excludedVariantIds.includes(variant.Id) ||
                                      //   checkAdded
                                      // }
                                    >
                                      {/* {checkAdded ? "Added" : "Add to cart"} */}
                                      Remove{" "}
                                      {isSubmitting && (
                                        <Spinner
                                          animation="grow"
                                          role="status"
                                          className="ml-2"
                                          size="sm"
                                        >
                                          <span className="visually-hidden"></span>
                                        </Spinner>
                                      )}
                                    </Button>
                                  ) : (
                                    <Button
                                      onClick={addToCart}
                                      className="srv-act-action"
                                      disabled={isSubmitting}
                                      //   disabled={
                                      //     excludedVariantIds.includes(variant.Id) ||
                                      //     checkAdded
                                      //   }
                                    >
                                      Add to cart{" "}
                                      {isSubmitting && (
                                        <Spinner
                                          animation="grow"
                                          role="status"
                                          className="ml-2"
                                          size="sm"
                                        >
                                          <span className="visually-hidden"></span>
                                        </Spinner>
                                      )}
                                    </Button>
                                  )}
                                </>
                              ) : (
                                <>
                                  <Button
                                    onClick={() => {
                                      localStorage.setItem(
                                        "product-id",
                                        variant.Id
                                      );
                                      if (showQuoteSelect) {
                                        setShowQuoteSelect(false);
                                        localStorage.removeItem(
                                          "isQuoterequest"
                                        );
                                        setCartJourney(workshopPurchase);
                                        let tyreItem = cart.tyreQuotation;
                                        tyreItem.isProceed = false;
                                        tyreItem.width = null;
                                        tyreItem.height = null;
                                        tyreItem.rim = null;
                                        tyreItem.data = null;
                                        setCartTypeParameter(tyreItem);
                                        let item = cart.batteryQuotation;
                                        item.isProceed = false;
                                        item.data = null;
                                        item.type = null;
                                        setCartBatteryParameter(item);
                                        return;
                                      }
                                      handleWorkshopSelection();
                                    }}
                                    className={`srv-act-action ${
                                      variant.Cost > 0 || variant.Cost < 0
                                        ? "shine-animation-new"
                                        : ""
                                    } variant-${index} ${
                                      showQuoteSelect
                                        ? isMobile
                                          ? "quote-yellow"
                                          : "quote-yellow"
                                        : ""
                                    } glare-animation`}
                                    style={
                                      variant.Cost <= 0
                                        ? {
                                            padding: showQuoteSelect
                                              ? "0px 50px"
                                              : "0px 35px",
                                            marginTop: "5px",
                                            lineHeight: "13px",
                                            fontSize: "13px",
                                            // marginLeft: isMobile
                                            //   ? "94px"
                                            //   : "0px",
                                          }
                                        : {
                                            lineHeight: "13px",
                                            fontSize: "13px",
                                          }
                                    }
                                    disabled={isSubmitting}
                                  >
                                    {/* {variant.Cost > 0 ? "Select" : "Request Quote"} */}
                                    {variant.Cost > 0
                                      ? "Select"
                                      : variant.Cost < 0 &&
                                        !showQuoteSelect &&
                                        !isQuoterequest
                                      ? "Request Quote"
                                      : "Remove"}
                                    {/* {variant.Id == 55 ? "Select" : "Request Quote"} */}{" "}
                                    {isSubmitting && (
                                      <Spinner
                                        animation="grow"
                                        role="status"
                                        className="ml-2"
                                        size="sm"
                                      >
                                        <span className="visually-hidden"></span>
                                      </Spinner>
                                    )}
                                  </Button>
                                </>
                              )}
                            </>
                          )}
                        </>
                      )
                    ) : (
                      <span
                        style={{
                          fontSize: "11px",
                          border: "0px",
                          background: "#0451be",
                          color: "white",
                        }}
                        className={
                          "ob-button mx-2 mt-0 tour-1 ob-button-custom"
                        }
                        onClick={() => {
                          setShowCarPopUp(true);
                        }}
                      >
                        Choose Your Car
                      </span>
                    )}
                    <div className="oft-lbs">
                      {variant.Offers && variant.Offers?.length ? (
                        <label
                          className="pl-offer-label"
                          title={"Offer Available"}
                          onClick={() => handleshowOffers(variant.Offers)}
                        >
                          <img
                            style={{
                              position: "static",
                              paddingRight: "5px",
                            }}
                            src="/assets/products/party-icon.webp"
                          />
                          {/* {variant.Offers?.length}{" "} */}
                          {variant?.Offers?.length == 1
                            ? "Offer"
                            : "Offers"}{" "}
                          Available
                        </label>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      </div>
      <Modal
        show={changeBrandModalShow}
        onHide={() => setChangeBrandModalShow(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Choose Preferred Brand</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            {variant.Products.map((product) => (
              <Row className="justify-content-between align-items-center border-bottom">
                <div class="oil-brand-modal-name">
                  <h2>{product.Name}</h2>
                  <span>{product.WorkshopCount} Workshops</span>
                </div>
                <div class="oil-br-prz">
                  <span>Best Price</span>
                  <label>AED {product.Cost}</label>
                </div>
                <div class="oil-br-sl">
                  <button
                    className={
                      defaultProduct?.Id === product.Id
                        ? "srv-act-action-sl "
                        : "srv-act-action shine-animation-new"
                    }
                    style={{
                      borderRadius: 20,
                      fontSize: "13px",
                      lineHeight: "13px",
                    }}
                    onClick={() => changeProduct(product)}
                    disabled={defaultProduct?.Id === product.Id}
                  >
                    {defaultProduct?.Id === product.Id ? "Selected" : "Select"}
                  </button>
                </div>
              </Row>
            ))}
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    globalData: state.globalData,
    apiData: state.apiData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCartStage: (stage) => {
      dispatch(setCartStage(stage));
    },
    setCartJourney: (stage) => {
      dispatch(setCartJourney(stage));
    },
    AppliedCartOffers: (data) => {
      dispatch(AppliedCartOffers(data));
    },
    setCartProducts: (products) => {
      dispatch(setCartProducts(products));
    },
    setCartJobItems: (products) => {
      dispatch(setCartJobItems(products));
    },
    setLayer: (status) => {
      dispatch(setLayer(status));
    },
    fetchCartAddons: (workshopId, variantId, carModeId) => {
      dispatch(fetchCartAddons(workshopId, variantId, carModeId));
    },
    getWorkshopFilterMap: (
      size,
      page,
      lat,
      lang,
      vId,
      mId,
      filter,
      brandId
    ) => {
      dispatch(
        getWorkshopFilterMap(size, page, lat, lang, vId, mId, filter, brandId)
      );
    },
    getWorkshopFilterMapMultiple: (
      size,
      page,
      lat,
      lang,
      vIds,
      mId,
      filter
    ) => {
      dispatch(
        getWorkshopFilterMapMultiple(size, page, lat, lang, vIds, mId, filter)
      );
    },
    setCartWorkshop: (data) => {
      dispatch(setCartWorkshop(data));
    },
    setShowMobileIstand: (flag) => {
      dispatch(setShowMobileIstand(flag));
    },
    setSelectedQuotationForm: (item) => {
      dispatch(setSelectedQuotationForm(item));
    },
    getCategory: () => {
      dispatch(getCategory());
    },
    setCartTypeParameter: (data) => {
      dispatch(setCartTypeParameter(data));
    },
    getVariants: (id, mId, WId) => {
      dispatch(getVariants(id, mId, WId));
    },
    setCartBatteryParameter: (data) => {
      dispatch(setCartBatteryParameter(data));
    },
    getWorkshopsProductCategory: (id, mid) => {
      dispatch(getWorkshopsProductCategory(id, mid));
    },
    getWorkshopsJourneyVariant: (wid, id, mid) => {
      dispatch(getWorkshopsJourneyVariant(wid, id, mid));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceListItem);
